import { css } from "@emotion/react";
import settings from "@settings";

export const featureList = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    boxShadow: settings.shadows.regular,
    borderRadius: settings.borderRadius.medium,
})

export const featureElement = (lastIndex: boolean) => css({
    display: 'flex',    
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    borderBottom: !lastIndex ?  `1px solid ${settings.colors.grey}` : 'none',
    padding: '.6rem',

})

